import { CellProps } from 'react-table';
import { useMemo } from 'react';

import { IBehaviourPreviewVM } from '../BehaviourPreviewVM';
import DateField from 'src/components/common/Table/DateField';
import StatusField from '../../../helpers/table/StatusField';
import TextField from 'src/components/common/Table/TextField';
import AuthorField from '../../../helpers/table/AuthorField';

export const useHistoryTableColumn = (): any[] => {
  return useMemo(
    () => [
      {
        id: 'creationDate',
        accessor: 'creationDate',
        sortType: 'datetime',
        sortable: true,
        width: '15%',
        Cell: (props: CellProps<IBehaviourPreviewVM>) => {
          const date = props.cell.value;

          return <DateField date={date} />;
        },
      },
      {
        accessor: 'label',
        width: '50%',
        Cell: (props: CellProps<IBehaviourPreviewVM>) => {
          const label = props.cell.value;

          return <TextField label={label} variant={'h5'} />;
        },
      },
      {
        accessor: 'answerType',
        width: '20%',
        Cell: (props: CellProps<IBehaviourPreviewVM>) => {
          const label = props.cell.value;

          return <AuthorField value={label} />;
        },
      },
      {
        accessor: 'status',
        width: '15%',
        sortable: true,
        Cell: (props: CellProps<IBehaviourPreviewVM>) => {
          const status = props.cell.value;

          return <StatusField status={status} />;
        },
      },
    ],
    [],
  );
};
